<template>
  <!-- 发票弹框 -->
  <div id="invoicePage">
    <van-popup
      v-model="show"
      @close="closePopup"
      position="bottom"
      closeable
      round
      :style="{
        minHeight: '70%',
        maxHeight: '92%',
        paddingTop: '10px',
        paddingBottom: '30px',
      }"
      get-container="body"
    >
      <div id="invoicePageContent">
        <div class="title">发票</div>
        <div class="invoiceMsg">
          <div class="fapiao">
            <h4>发票类型</h4>
            <div class="item">
              <van-button
                round
                size="small"
                :type="type_1 ? 'info' : 'default'"
                @click="changeButton('1')"
                >普通发票</van-button
              >
              <!-- :disabled="changeInvoice" -->
              <van-button
                round
                size="small"
                :type="type_1 ? 'default' : 'info'"
                @click="changeButton('2')"
                style="margin-left: 10px"
                >增值税专用发票</van-button
              >
            </div>
          </div>
          <div class="line"></div>
          <div class="fapiao">
            <h4>发票抬头</h4>
            <div class="item">
              <van-button
                round
                size="small"
                :type="type_2 ? 'default' : 'info'"
                @click="changeButton('4')"
                >单位</van-button
              >
              <van-button
                v-if="type_1"
                round
                size="small"
                :type="type_2 ? 'info' : 'default'"
                @click="changeButton('3')"
                style="margin-left: 10px"
                >个人</van-button
              >
            </div>
          </div>
          <!-- 内容 -->
          <div class="invoiceItemMsg">
            <van-form
              v-if="type_1 && type_2"
              @submit="onSubmit"
              @failed="failed"
              key="name"
            >
              <van-field
                v-model="personal.headername"
                clearable
                required
                label="个人名称"
                :rules="[{ required: true, message: '个人名称不能为空' }]"
                placeholder="请填写个人名称"
              />
              <!-- <van-field
                class="money"
                v-model="totalPrice"
                label="总金额"
                disabled
              /> -->
              <h4 style="margin-top:10px">收票人信息</h4>
              <van-field
                v-model="personal.postemail"
                clearable
                label="电子邮箱"
                placeholder="请填写电子邮箱"
              />
              <van-field
                v-model="personal.postmobile"
                clearable
                label="联系电话"
                placeholder="请填写联系电话"
              />

              <div style="margin: 16px">
                <van-tabbar
                  style="
                    background-color: #fff;
                    diaplay: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <van-button
                    style="width: 80%;height:40px"
                    type="info"
                    block
                    round
                    size="small"
                    native-type="submit"
                    >确定</van-button
                  >
                </van-tabbar>
              </div>
            </van-form>
            <van-form
              v-else-if="type_1 && !type_2"
              @submit="onSubmit"
              @failed="failed"
              key="name_2"
            >
              <van-field
                v-model="unit.headername"
                clearable
                required
                label="单位名称"
                placeholder="请填写单位名称"
                :rules="[{ required: true, message: '单位名称不能为空' }]"
              />
              <van-field
                v-model="unit.headercode"
                clearable
                required
                label="纳税人识别号"
                placeholder="请填写纳税人识别号"
                :rules="[{ required: true, message: '纳税人识别号不能为空' }]"
              />

              <van-field
                v-model="unit.officeaddress"
                clearable
                label="注册地址"
                placeholder="请填写注册地址"
              />
              <van-field
                v-model="unit.mobilenumber"
                clearable
                label="注册电话"
                placeholder="请填写注册电话"
              />
              <van-field
                v-model="unit.bankname"
                clearable
                label="开户银行"
                placeholder="请填写开户银行"
              />
              <van-field
                v-model="unit.bankaccount"
                clearable
                label="银行账号"
                placeholder="请填写银行账号"
              />
              <h4 style="margin-top:10px">收票人信息</h4>
              <van-field
                v-model="unit.postemail"
                clearable
                label="电子邮箱"
                placeholder="请填写电子邮箱"
              />
              <van-field
                v-model="unit.postmobile"
                clearable
                label="联系电话"
                placeholder="请填写联系电话"
              />

              <!-- <van-field
                class="money"
                v-model="totalPrice"
                label="总金额"
                disabled
              /> -->
              <div style="margin: 16px">
                <van-tabbar
                  style="
                    background-color: #fff;
                    diaplay: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <van-button
                    style="width: 80%;height:40px"
                    type="info"
                    block
                    round
                    size="small"
                    native-type="submit"
                    >确定</van-button
                  >
                </van-tabbar>
              </div>
            </van-form>
            <van-form v-else @submit="onSubmit" @failed="failed" key="name_3">
              <van-field
                v-model="valueAddedTax.headername"
                clearable
                required
                label="单位名称"
                placeholder="请填写单位名称"
                :rules="[{ required: true, message: '名称不能为空' }]"
              />
              <van-field
                v-model="valueAddedTax.headercode"
                clearable
                required
                label="纳税人识别号"
                placeholder="请填写纳税人识别号"
                :rules="[{ required: true, message: '请填写纳税人识别号' }]"
              />
              <van-field
                v-model="valueAddedTax.officeaddress"
                clearable
                required
                label="注册地址"
                placeholder="请填写注册地址"
                :rules="[{ required: true, message: '请填写注册地址' }]"
              />
              <van-field
                v-model="valueAddedTax.mobilenumber"
                clearable
                required
                label="注册电话"
                placeholder="请填写注册电话"
                :rules="[{ required: true, message: '请填写注册电话' }]"
              />
              <van-field
                v-model="valueAddedTax.bankname"
                clearable
                required
                label="开户银行"
                placeholder="请填写开户银行"
                :rules="[{ required: true, message: '请填写开户银行' }]"
              />
              <van-field
                v-model="valueAddedTax.bankaccount"
                clearable
                required
                label="银行账号"
                placeholder="请填写银行账号"
                :rules="[{ required: true, message: '请填写银行账号' }]"
              />
              <h4 style="margin-top:10px">收票人信息</h4>
              <van-field
                v-model="valueAddedTax.postaddress"
                clearable
                required
                label="邮寄地址"
                placeholder="请填写邮寄地址"
                :rules="[{ required: true, message: '请填写邮寄地址' }]"
              />
              <van-field
                v-model="valueAddedTax.postmobile"
                clearable
                required
                label="联系电话"
                placeholder="请填写联系电话"
                :rules="[{ required: true, message: '请填写联系电话' }]"
              />
              <van-field
                v-model="valueAddedTax.postemail"
                clearable
                label="电子邮箱"
                placeholder="请填写电子邮箱"
              />

              <!-- <van-field
                class="money"
                v-model="totalPrice"
                label="总金额"
                disabled
              /> -->
              <div style="margin: 16px">
                <van-tabbar
                  style="
                    background-color: #fff;
                    diaplay: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <van-button
                    style="width: 80%;height:40px"
                    type="info"
                    block
                    round
                    size="small"
                    native-type="submit"
                    >确定</van-button
                  >
                </van-tabbar>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    // changeInvoice: Boolean,
  },
  data() {
    return {
      totalPrice: 0,
      show: false,
      type_1: true, // 发票类型
      type_2: true, // 发票抬头
      personal: {
        // 个人
        headertype: 1,
        headername: "个人",
        headercode: "",
        officeaddress: "",
        mobilenumber: "",
        bankname: "",
        bankaccount: "",
        postemail: "",
        postmobile: "",
      },
      unit: {
        // 单位
        headertype: 2,
        headername: "",
        headercode: "",
        officeaddress: "",
        mobilenumber: "",
        bankname: "",
        bankaccount: "",
        postemail: "",
        postmobile: "",
      },
      valueAddedTax: {
        // 增值税
        headertype: 2,
        headername: "",
        headercode: "",
        officeaddress: "",
        mobilenumber: "",
        bankname: "",
        bankaccount: "",
        postemail: "",
        postmobile: "",
        postaddress: "",
      },
      firstMessage: {}, // 开发票得内容
    };
  },

  methods: {
    // 确定
    onSubmit() {
      if (this.type_1 && this.type_2) {
        let params = {
          invoicetype: 1, // 0 不开票，1 普通发票，2 增值税发票
          invoiceheader: this.personal,
        };
        let word = "普通发票 个人";
        this.$emit("getInvoiceParams", params, word);
      } else if (this.type_1 && !this.type_2) {
        let params = {
          invoicetype: 1, // 0 不开票，1 普通发票，2 增值税发票
          invoiceheader: this.unit,
        };
        let word = "普通发票 单位";
        this.$emit("getInvoiceParams", params, word);
      } else if (!this.type_1 && !this.type_2) {
        let params = {
          invoicetype: 2, // 0 不开票，1 普通发票，2 增值税发票
          invoiceheader: this.valueAddedTax,
        };
        let word = "增值税专用发票";
        this.$emit("getInvoiceParams", params, word);
      }
      if (this.changeInvoice) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    failed() {
      this.show = true;
    },
    // 打开弹框
    openpopup() {
      this.show = true;
    },
    // 给输入框的内容赋值
    inputMsg(params) {
      this.firstMessage = JSON.parse(JSON.stringify(params));
      if (params.headertype === 1) {
        // 个人
        this.type_2 = true;
        this.personal = JSON.parse(JSON.stringify(params));
      } else if (params.headertype === 2) {
        // 单位
        this.type_2 = false;
        this.unit = JSON.parse(JSON.stringify(params));
        this.valueAddedTax = JSON.parse(JSON.stringify(params));
        this.personal.headername = "个人";
      } else {
        this.type_2 = true;
        this.personal.headername = "个人";
      }
    },
    // 价格
    getTotalMoney(price) {
      this.totalPrice = this.toDecimal(price);
    },
    changeButton(num) {
      if (num === "1" && this.type_1 != true) {
        this.type_1 = true;
        this.type_2 = false;
      } else if (num === "2" && this.type_1 != false) {
        this.type_1 = false;
        this.type_2 = false;
      } else if (num === "3") {
        this.type_2 = true;
      } else if (num === "4") {
        this.type_2 = false;
      }
    },
    closePopup() {
      // this.type_1 = true;
      // this.type_2 = false
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    },
  },
};
</script>
<style lang="less" scoped>
.fapiao {
  // 弹框按钮的颜色
  /deep/.van-button--info {
    color: #fff;
    background: linear-gradient(to right, #0077F5, #0077F5);
    border: 0.02667rem solid #00A7FA;
  }
}
</style>
<style lang="less">
#invoicePageContent {
  margin-bottom: 1.5rem;
  .title {
    font-size: 17px;
    margin: 15px 0;
    color: #000;
    font-weight: bold;
    text-align: center;
  }
  .invoiceMsg {
    padding: 0 20px;
    .fapiao {
      margin: 20px 0;
      & > h4 {
        margin-top: 0;
      }
      h4 {
        margin: 10px 0;
        font-weight: bold;
      }
      .van-button {
        min-width: 60px;
      }
    }
    .invoiceItemMsg {
      margin-top: 20px;
      .button {
        padding: 0 20px;
        margin-top: 30px;
      }
      .money {
        border: none;
      }
    }
    
    .van-cell {
      border: 1px solid #ededef;
      margin-top: 10px;
      border-radius: 6px;
    }
    .van-cell:not(:last-child)::after {
      border-bottom: none;
    }
  }
}
.van-field__control {
  font-size: 12px;
}
</style>
